module.exports = __webpack_public_path__ + "img/AreiasUniao.851bb6c9.png";